export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20gaming%20atmosphere%20background%20with%20abstract%20geometric%20shapes%2C%20emerald%20green%20and%20gold%20accents%2C%20modern%20minimalist%20style%2C%20smooth%20gradient%20from%20dark%20to%20medium%20tones%2C%20luxurious%20gaming%20club%20vibe%2C%20no%20text%2C%20clean%20and%20sophisticated&width=1920&height=900&seq=hero-bg-ng-01&orientation=landscape"
          alt="NG南宫游戏平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-medium mb-6 border border-accent-500/30">
          官方正版 · 安全下载
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
          NG南宫
          <span className="block text-accent-400 mt-2">官方正版APP下载平台</span>
        </h1>

        <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto mb-10 leading-relaxed">
          NG南宫下载链接官方入口，提供最新版本iOS/Android安装包，安全无病毒，一键下载即玩，支持多平台设备，极速安装体验，立即获取NG南宫官方正版下载链接。
        </p>

        <div id="download" className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap group"
          >
            <i className="ri-apple-fill text-lg"></i>
            <span>iOS 版下载</span>
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
          </a>
          <a
            href="#"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm hover:bg-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap border border-white/20 group"
          >
            <i className="ri-android-fill text-lg"></i>
            <span>Android 版下载</span>
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8 text-white/50 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400"></i> 安全无病毒
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-download-cloud-line text-accent-400"></i> 极速下载
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-smartphone-line text-accent-400"></i> 多平台支持
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}